<template>
    <!-- Dialog -->
    <v-dialog v-model="getDialog" :width="$vuetify.breakpoint.smAndDown ? '100%' : 470"
        :fullscreen="$vuetify.breakpoint.xs" persistent @keydown.esc="chiudi()" @keydown.ctrl.enter="formSubmit">
        <v-form ref="formIns" @submit.prevent="formSubmit()" lazy-validation style="height: 100% !important;">
            <v-card class="dialog-card" :class="{ 'dialog-mobile': $vuetify.breakpoint.smAndDown }">
                <v-card-title :class="!$vuetify.breakpoint.smAndDown ? 'headline pa-3' : 'pl-1 pr-0'"
                    style="background-color: #424242; color: #fff" primary-title>
                    {{ $functions.formatISODate(data) }} - {{ utente }}
                    <v-select :items="tipiOre" solo v-model="dati.tipologia" hide-details class="ml-2"
                        :style="{ maxWidth: '170px' }" required :readonly="inputReadonly()" />

                    <v-avatar size="16" class="ml-2" :style="{ backgroundColor: coloreEvento(dati.tipologia) }"
                        :key="dati.tipologia" />

                </v-card-title>

                <v-card-text>
                    <v-container fluid :class="{ 'container-mobile': $vuetify.breakpoint.smAndDown }">
                        <v-row dense>
                            <v-col cols="12">
                                <v-autocomplete :items="clienti" label="Cliente" item-text="ragSoc" item-value="ragSoc"
                                    v-model="clienteSel" return-object ref="inputCliente" clearable
                                    @change="setCliente()" autofocus :disabled="inputReadonly()" />
                            </v-col>

                            <!-- Orari -->
                            <v-col cols="12">
                                <v-row dense>
                                    <v-col cols="4">
                                        <v-menu v-model="menuOraInizio" :close-on-content-click="false" offset-y
                                            max-width="290px" min-width="290px"
                                            :disabled="dati.giornoIntero || inputReadonly()">
                                            <template v-slot:activator="{ on, attrs }">
                                                <v-text-field v-model="dati.oraInizio" label="Ora inizio" v-bind="attrs"
                                                    clearable @click:prepend="menuOraInizio = true"
                                                    :disabled="dati.giornoIntero || inputReadonly()"
                                                    @blur="normalizzaOra('oraInizio')">
                                                    <template v-slot:prepend>
                                                        <v-icon tabindex="-1"
                                                            @click="menuOraInizio = true">access_time</v-icon>
                                                    </template>
                                                </v-text-field>
                                            </template>
                                            <v-time-picker v-if="menuOraInizio" v-model="dati.oraInizio" full-width
                                                @click:minute="menuOraInizio = false" format="24hr" />
                                        </v-menu>
                                    </v-col>

                                    <v-col cols="1" class="d-flex align-center justify-center pa-0">
                                        <span style="font-size: 1.2rem;">-</span>
                                    </v-col>

                                    <v-col cols="4">
                                        <v-menu v-model="menuOraFine" :close-on-content-click="false" offset-y
                                            max-width="290px" min-width="290px"
                                            :disabled="dati.giornoIntero || inputReadonly()">
                                            <template v-slot:activator="{ on, attrs }">
                                                <v-text-field v-model="dati.oraFine" label="Ora fine" v-bind="attrs"
                                                    clearable @click:prepend="menuOraFine = true"
                                                    :disabled="dati.giornoIntero || inputReadonly()"
                                                    @blur="normalizzaOra('oraFine')">
                                                    <template v-slot:prepend>
                                                        <v-icon tabindex="-1"
                                                            @click="menuOraFine = true">access_time</v-icon>
                                                    </template>
                                                </v-text-field>
                                            </template>
                                            <v-time-picker v-if="menuOraFine" v-model="dati.oraFine" full-width
                                                @click:minute="menuOraFine = false" format="24hr" />
                                        </v-menu>
                                    </v-col>

                                    <v-col cols="3">
                                        <v-checkbox v-model="dati.giornoIntero" label="Tutto il giorno"
                                            :readonly="inputReadonly()" />
                                    </v-col>
                                </v-row>
                            </v-col>

                            <!-- Destinazione e importo -->
                            <v-col cols="12">
                                <v-row dense>
                                    <v-col cols="7">
                                        <v-select :items="destinazioni" v-model="dati.destinazione" label="Destinazione"
                                            :readonly="inputReadonly()" />
                                    </v-col>
                                    <v-col cols="4">
                                        <v-text-field v-model="dati.importoPrevisto" label="Importo previsto"
                                            :readonly="inputReadonly()" />
                                    </v-col>
                                    <v-col cols="1" class="mt-4">
                                        <v-icon @click="getPrezzoCliente()"
                                            v-tooltip.bottom="'Calcola da importo anagrafica clienti (se tutto il giorno stima 8 ore)'">cloud_sync</v-icon>
                                    </v-col>
                                </v-row>
                            </v-col>

                            <v-col cols="12">
                                <v-textarea outlined label="Descrizione" v-model="dati.descrizione" hide-details
                                    auto-grow @keydown.ctrl.enter.prevent="formSubmit" :readonly="inputReadonly()" />
                            </v-col>

                            <v-col cols="12">
                                <v-autocomplete outlined label="Partecipanti" v-model="dati.partecipanti" hide-details
                                    :items="utenti" multiple clearable :disabled="inputReadonly()" />
                            </v-col>

                            <v-col cols="12">
                                <v-checkbox v-model="dati.completato" hide-details label="Segna come completato"
                                    :readonly="inputReadonly()" />
                            </v-col>
                        </v-row>
                    </v-container>
                </v-card-text>

                <v-card-actions>
                    <v-btn color="primary" text @click="chiudi()">Annulla</v-btn>
                    <v-btn @click="elimina" text icon :disabled="inputReadonly()">
                        <v-icon>delete</v-icon>
                    </v-btn>
                    <v-spacer />
                    <v-btn color="primary" type="submit" :disabled="inputReadonly()">Salva</v-btn>
                </v-card-actions>
            </v-card>
        </v-form>
    </v-dialog>

</template>



<script>
import {
    get_tasks,
    save_task,
    del_task,
} from "@/api/api.calendar.js";

import storage from "@/services/storage";

export default {
    props: {
        dialog: { type: Boolean, default: false },
        data: { type: String, default: "" },
        prog: { type: Number, default: 0 },
        clienti: {
            type: Array,
            default: () => {
                return [];
            },
        },
        utenti: {
            type: Array,
            default: () => {
                return [];
            },
        },
        utente: { type: String, default: "" },
    },

    data: () => ({
        dati: {
            data: "",
            prog: 0,
            descrizione: "",
            utenteCreazione: "",
            importoPrevisto: 0,
            destinazione: "",
            tipologia: "",
            oraInizio: null,
            oraFine: null,
            giornoIntero: false,
            codAnagrafica: "",
            completato: false,
            partecipanti: [],
        },
        menuOraInizio: false,
        menuOraFine: false,

        clienteSel: {},
        tipiImporto: ["Orario", "Totale"],
        destinazioni: ["Cliente", "Ufficio"],
        tipiOre: ["Attivita", "Appuntamento", "Nota"],

        rules: {
            required: (value) => !!value || "Richiesto.",

            number: (value) => {
                return (
                    (/^\d+$/g.test(value) && parseInt(value) > 0) || "Numero non valido."
                );
            },

            numberOptional: (value) => {
                if (value == undefined) return true;
                if (value.length == 0) return true;
                if (!/^\d+$/g.test(value) || parseInt(value) < 0)
                    return "Numero non valido.";
            },
        },
    }),

    computed: {
        getDialog: {
            get: function () {
                return this.dialog;
            },
            set: function (value) {
                if (!value) {
                    this.chiudi();
                }
            },
        },

        username: {
            get: function () {
                return storage.getUsername();
            },
        }
    },

    watch: {
        dialog(val) {
            if (val) {
                this.$nextTick(() => this.$refs.formIns.resetValidation());

                //this.$nextTick(() => this.$refs.inputCliente.focus());

                this.caricaDati();
            }
        },

        "dati.giornoIntero": function (val) {
            if (val) {
                this.dati.oraInizio = null;
                this.dati.oraFine = null;
            }
        },
    },

    methods: {
        async caricaDati() {
            // Reset
            this.clienteSel = [];

            // Controllo nuovo
            if (this.prog == -1) {
                this.dati.data = this.data;
                this.dati.prog = this.prog;
                this.dati.utenteCreazione = this.utente;
                this.dati.partecipanti = [this.utente];
                this.dati.tipologia = this.tipiOre[0];
            }
            else {
                let par = "dettaglio/" + this.data + "/" + this.prog;

                try {
                    let res = await get_tasks(par);
                    this.dati = res.data;

                    // Seleziono il cliente
                    this.clienteSel = this.clienti.find(
                        (f) => f.codAnagrafica == this.dati.codAnagrafica
                    );
                    this.dati.partecipanti = this.dati.utenti.split(',');
                } catch (error) {
                    console.log(error);
                    this.$toast.info(this.$functions.getErrorMsg(error));
                }
            }
        },

        async formSubmit() {
            if (this.$refs.formIns.validate() === false) return;

            if (!this.clienteSel && !this.dati.descrizione) {
                this.$toast.alert("Inserire un cliente oppure una descrizione");
                return;
            }

            //  o "Tutto il giorno" OPPURE un orario valido
            if (!this.dati.giornoIntero) {
                if (!this.dati.oraInizio || !this.dati.oraFine) {
                    this.$toast.alert("Inserire un orario valido");
                    return;
                }

                this.normalizzaOra("oraInzio");
                this.normalizzaOra("oraFine");

                const isValidTime = (t) => /^([01]\d|2[0-3]):([0-5]\d)$/.test(t);
                if (!isValidTime(this.dati.oraInizio) || !isValidTime(this.dati.oraFine)) {
                    this.$toast.alert("Formato orario non valido (hh:mm)");
                    return;
                }

                // l'ora di fine deve essere maggiore dell'ora di inizio
                const toMinutes = (t) => {
                    const [h, m] = t.split(":").map(Number);
                    return h * 60 + m;
                };

                if (toMinutes(this.dati.oraFine) <= toMinutes(this.dati.oraInizio)) {
                    this.$toast.alert("L'orario di fine deve essere successivo a quello di inizio");
                    return;
                }
            }

            this.dati.utenti = this.dati.partecipanti.join(',');
            if (isNaN(this.dati.importoPrevisto)) this.dati.importoPrevisto = 0;
            await save_task(this.dati, "");
            this.chiudi(true);
        },

        chiudi(aggiorna) {
            this.dati = {};
            this.$emit("chiudi", aggiorna);
        },

        async elimina() {
            if (this.prog == -1) return;

            let confirm = await this.$confirm.open(
                "Elimina",
                "Vuoi eliminare l'attività ?"
            );

            if (!confirm) return;

            try {
                await del_task(this.data + "/" + this.prog);

                // Chiudo la videata
                this.chiudi(true);
            } catch (error) {
                this.$toast.alert(this.$functions.getErrorMsg(error));
            }
        },

        setCliente() {
            if (!this.clienteSel) {
                this.dati.codAnagrafica = "";
            } else {
                this.dati.codAnagrafica = this.clienteSel.codAnagrafica;
            }
        },

        normalizzaOra(campo) {
            let val = this.dati[campo];
            this.$set(this.dati, campo, this.$functions.normalizzaOra(val))
            if (!this.dati[campo]) return;
            if (campo == "oraInizio" && (this.dati.oraFine == "" || this.dati.oraFine == null)) {
                let [h, m] = this.dati.oraInizio.split(":").map(Number);
                let date = new Date();
                date.setHours(h, m || 0, 0, 0);
                date.setHours(date.getHours() + 1);

                let hh = String(date.getHours()).padStart(2, "0");
                let mm = String(date.getMinutes()).padStart(2, "0");

                this.$set(this.dati, "oraFine", `${hh}:${mm}`)
            }
        },

        coloreEvento(tipo) {
            switch (tipo) {
                case 'Appuntamento': return '#F9A825';
                case 'Nota': return '#009688';
                case 'Attivita': return '#8BC34A';
                default: return 'secondary';
            }
        },

        inputReadonly() {
            // ritorna true se il controllo non può essere modificato (l'utente corrente non è proprietario dell'evento)
            if (!this.dati.utenti) return false;
            let canEdit = this.dati.utenti.includes(this.username) || this.dati.utenteCreazione == this.username;
            return !canEdit;
        },

        getPrezzoCliente() {
            if (!this.dati.codAnagrafica || this.dati.codAnagrafica == "") return;

            if (!this.dati.oraInizio || !this.dati.oraFine) {
                this.dati.importoPrevisto = this.clienteSel.importo * 8;
                return;
            }

            const [hInizio, mInizio] = this.dati.oraInizio.split(':').map(Number)
            const [hFine, mFine] = this.dati.oraFine.split(':').map(Number)

            const inizio = new Date(0, 0, 0, hInizio, mInizio)
            const fine = new Date(0, 0, 0, hFine, mFine)

            let diffMinuti = (fine - inizio) / 60000
            if (diffMinuti < 0) diffMinuti += 24 * 60

            this.dati.importoPrevisto = (diffMinuti / 60) * this.clienteSel.importo;
        },
    },

};
</script>

<style scoped>
.dialog-mobile {
    margin: 0 !important;
    border-radius: 0 !important;
    height: 100% !important;
}

.container-mobile {
    margin: 0;
    padding: 0;
}

.v-card-text .v-row {
    margin-left: -4px !important;
    margin-right: -4px !important;
}

.v-col {
    padding-top: 4px !important;
    padding-bottom: 4px !important;
}
</style>
